import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  IsAllowed,
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { Institution, InstitutionView } from 'cb-model';

export const InstitutionSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(InstitutionView);
  const gCacheQueryItem = useCacheQuery(InstitutionView, queryOptions);
  return (
    <>
      <PageTitle verb="Search" entity={InstitutionView} />
      <Section>
        <IsAllowed entity={Institution} action="create">
          <Link to="/admin/institution/create">
            <Button size="sm" variant="primary">
              Create a new Institution
            </Button>
          </Link>
          <div className="mb20px" />
        </IsAllowed>
        <PaginatorAndListSettings
          entity={InstitutionView}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
